import { render, staticRenderFns } from "./organization-unit-account-panel.vue?vue&type=template&id=4cca7f8c&scoped=true&"
import script from "./organization-unit-account-panel.vue?vue&type=script&lang=js&"
export * from "./organization-unit-account-panel.vue?vue&type=script&lang=js&"
import style0 from "./organization-unit-account-panel.vue?vue&type=style&index=0&id=4cca7f8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca7f8c",
  null
  
)

export default component.exports